import { Components } from '@mui/material';
import { Theme } from '@mui/material/styles';

const muiCircularProgressStyles: Components<Theme> = {
  MuiCircularProgress: {
    styleOverrides: {
      root: {
        height: '20px !important',
        width: '20px !important'
      }
    }
  }
};

export default muiCircularProgressStyles;
